import { GraduationCap, FlaskConical, Users, Sparkles, ShieldCheck, Award, BookOpenCheck, Pill, FlaskRound, Microscope, Stethoscope, Beaker } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

const ICONS = {
  GraduationCap, FlaskConical, Users, Sparkles, ShieldCheck, Award, BookOpenCheck,
  Pill, FlaskRound, Microscope, Stethoscope, Beaker,
};

export function Icon({ name, className }) {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp className={className} />;
}

export default function About() {
  const { content } = useContent();
  const a = content?.about || {};
  if (a.enabled === false) return null;
  const points = a.points || [];

  return (
    <section id="about" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="rounded-2xl overflow-hidden border border-border">
              {a.image_url && (
                <img src={a.image_url} alt="Campus" className="w-full h-[460px] object-cover" />
              )}
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="overline">{a.eyebrow}</div>
            <h2 className="font-display mt-3 text-3xl lg:text-4xl font-medium tracking-tight leading-tight">
              {a.heading}
            </h2>
            <p className="mt-5 text-muted-foreground text-base lg:text-lg leading-relaxed max-w-2xl">
              {a.body}
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {points.map((p) => (
                <div
                  key={p.title}
                  data-testid={`about-point-${p.title.toLowerCase().replace(/\s+/g, '-')}`}
                  className="group p-5 rounded-xl bg-white border border-border hover:-translate-y-0.5 hover:shadow-lg hover:border-primary/30 transition-all"
                >
                  <Icon name={p.icon} className="h-5 w-5 text-primary" />
                  <h3 className="font-display mt-3 text-lg font-medium">{p.title}</h3>
                  <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
